import { Component } from 'react';
import { connect } from 'react-redux';

import { imageFile } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';
import { removeCartItem } from 'redux/cart/actions';

import ItemPrice from './ItemPrice';
import Quantity from './Quantity';
import EventItemData from './itemData/EventItemData';
// eslint-disable-next-line import/no-cycle
import GiftCardItemData from './itemData/GiftCardItemData';

class Item extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null
    };
  }

  handleRemove = (e) => {
    e.preventDefault();
    const { props } = this;
    const { item } = props;
    let useLoyaltyPoints = false;
    if (item.itemData?.useLoyaltyPoints) {
      useLoyaltyPoints = true;
    }
    props.removeCartItem(item.sku, useLoyaltyPoints);
  };

  handleError = (error) => {
    this.setState({ error });
  };

  render() {
    const { item, settings } = this.props;
    const { error } = this.state;
    let describedby;
    if (error) {
      describedby = { 'aria-describedby': 'qtyerror' };
    }
    return (
      <div>
        <div className="c7-cart-items__quantity">
          {error && (
            <span className="c7-product__error" aria-describedby="qtyerror">
              Error: {error}
            </span>
          )}
          <Quantity
            item={item}
            describedby={describedby}
            onError={this.handleError}
          />
        </div>
        <div className="c7-cart-items__image">
          <img src={imageFile(item.image, 'small')} alt={item.productTitle} />
        </div>
        <div className="c7-cart-items__title">
          {item.productTitle}
          <div className="c7-cart-items__title__variant">
            {item.productVariantTitle}
          </div>
          <EventItemData item={item} />
          <GiftCardItemData item={item} />
          <a
            href="#"
            onClick={this.handleRemove}
            aria-label={`Remove ${item.productTitle}`}
          >
            Remove
          </a>
        </div>
        <ItemPrice item={item} settings={settings} />
        <div className="c7-cart-items__item-total" aria-label="Extended price">
          {currencyFormat(item.price * item.quantity, settings)}
          <Points item={item} />
        </div>
      </div>
    );
  }
}

const Points = (props) => {
  const { item } = props;
  if (item.itemData?.loyaltyPoints) {
    return (
      <>
        <br />
        {item.itemData.loyaltyPoints * item.quantity} Points
      </>
    );
  }
  return null;
};

export default connect(null, { removeCartItem })(Item);
